import React from 'react';
import Loading from './Loading';

const Table = ({ columns, data, loading, onRowClick, emptyMessage = 'No hay datos para mostrar' }) => {
  if (loading) return <Loading />;

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-slate-700">
            {columns.map((col, i) => (
              <th 
                key={i} 
                className={`px-4 py-3 text-left text-sm font-semibold text-slate-400 ${col.className || ''}`}
                style={{ width: col.width }}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="px-4 py-8 text-center text-slate-500">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, i) => (
              <tr 
                key={row.id || i} 
                onClick={() => onRowClick && onRowClick(row)}
                className={`
                  border-b border-slate-700/50 hover:bg-slate-700/20 transition-colors
                  ${onRowClick ? 'cursor-pointer' : ''}
                `}
              >
                {columns.map((col, j) => (
                  <td key={j} className={`px-4 py-3 text-slate-300 ${col.cellClassName || ''}`}>
                    {col.render ? col.render(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
